// Resolve the backend base URL at runtime.
// Prefers same-origin when served from an Emergent deployment host so the
// frontend keeps working even if the build pipeline baked a stale URL.
const BUILD_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const getBackendUrl = () => {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname;
    if (host.endsWith('.emergent.host')) return window.location.origin;
  }
  return BUILD_BACKEND_URL;
};

export const BACKEND_URL = getBackendUrl();
